import { StateCreator } from "zustand";
import axios from "axios";
import { BASE_PATH } from "@/shared/constants/constant";
import usePermissionStore from "@/shared/store/usePermissionStore";

type BasicUser = {
  user_name?: string;
  role_name?: string;
  email?: string;
  user_id?: number;
  role_id?: number;
  special_permission?: string;
  features?: any[];
};

export type AuthSlice = {
  user: BasicUser | null;
  isAuthenticated: boolean;
  isLoading: boolean;
  login: (data: { user: any }) => void;
  logout: () => Promise<void>;
  stopLoading: () => void;
};

const createAuthSlice: StateCreator<AuthSlice> = (set) => ({
  user: null,
  isAuthenticated: false,
  isLoading: true,

  login: (data: { user: any }) => {
    const {
      user_name,
      role_name,
      email,
      user_id,
      role_id,
      special_permission,
      features,
    } = data.user ?? {};

    set({
      isAuthenticated: true,
      user: { user_name, role_name, email, user_id, role_id, special_permission, features },
    });
  },

  logout: async () => {
    try {
      await axios.post(
        `${BASE_PATH}/api/auth/logout`,
        {},
        { withCredentials: true },
      );
    } catch (e) {
      console.error("Logout API call failed", e);
    }

    // Clear permission store (in-memory)
    usePermissionStore.getState().clearPermissions();

    // Clear client state
    localStorage.removeItem("sidebar");
    localStorage.removeItem("user");

    set({
      isAuthenticated: false,
      user: null,
    });
  },

  stopLoading: () => {
    set({ isLoading: false });
  },
});

export default createAuthSlice;
